export default function PHP_dirname() {
  return (
    <div>
      <h1>PHP_dirname</h1>
    </div>
  );
}
